import { useDisableScroll } from 'lib/use-disable-scroll'
import { useEscape } from 'lib/use-escape'
import React, { FC, useRef } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import { Icon } from 'ui/icon'
import { PopupCover } from 'ui/popup-cover'

import { VideoProps } from '../../features/car/types'
import { Props as ImageProps } from '../image'
import { SliderSlick } from '../slider/SliderSlick'

export type Props = {
  activeSlide?: number
  activeSlideInPopup?: number
  onExit: () => void
  children?: React.ReactElement[]
  onActiveSlideChange: (value: number) => void
  isSwipingDisabled?: boolean
  additionalContent?: React.ReactChild
  images?: ImageProps[]
  videos?: VideoProps[]
  slickSliderVideosRef?: any
}

export const PreviewSlider: FC<Props> = ({
  children,
  activeSlide = 0,
  onExit,
  onActiveSlideChange,
  additionalContent,
  images,
  videos,
  slickSliderVideosRef
}) => {
  const totalCount = videos ? videos.length : images?.length

  useDisableScroll(true)
  useEscape(onExit)
  const slickSliderImagesRef = useRef<any>(null)

  return createPortal(
    <PopupCover onCoverClick={onExit}>
      <TopBar>
        <Count>
          {activeSlide + 1} / {totalCount}
        </Count>
        <ExitButton onClick={onExit}>
          <Icon name="cancel" size={1.3} />
        </ExitButton>
      </TopBar>
      {images && (
        <SliderSlick
          images={images}
          isInPopup={true}
          sliderRef={slickSliderImagesRef}
          activeSlide={activeSlide}
          onSlideChange={onActiveSlideChange}
        />
      )}

      {videos && (
        <SliderSlick
          videos={videos}
          isInPopup={true}
          activeSlide={activeSlide}
          sliderRef={slickSliderVideosRef}
          onSlideChange={onActiveSlideChange}
        />
      )}

      {additionalContent && <AdditionalContentWrapper>{additionalContent}</AdditionalContentWrapper>}
    </PopupCover>,
    document.body
  )
}

const TopBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[7]}`};
  background: rgba(0, 0, 0, 0.3);
`

const Count = styled.p`
  margin: 0;
  ${({ theme }) => theme.textStyles.h4};
  color: ${({ theme }) => theme.palette.white};
`

const ExitButton = styled.div`
  margin-left: auto;
  color: ${({ theme }) => theme.palette.grey[100]};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette.white};
  }
`

const AdditionalContentWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: ${({ theme }) => theme.spacing[3]};
  display: flex;
  transform: translateX(-50%);
`
